export default "__VITE_ASSET__BW0QDxvC__"